module.exports = __webpack_public_path__ + "img/z_ico.99a890f0.svg";